import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { BreakpointObserver } from '@angular/cdk/layout'

@Component({
  selector: 'mb-mpup-navigation',
  templateUrl: './mpup-navigation.component.html',
  styleUrls: ['./mpup-navigation.component.scss']
})
export class MpupNavigationComponent {

  private activeRoute!: string
  inventorySrc!: string
  transactionsSrc!: string
  accessPassesSrc!: string

  constructor (private router: Router, private breakpoint: BreakpointObserver) {
    this.activeRoute = router.url
    this.inventorySrc = this.getImagePath('inventory', this.isActive('/mpup/inventory'))
    this.transactionsSrc = this.getImagePath('transactions', this.isActive('/mpup/transactions'))
    this.accessPassesSrc = this.getImagePath('accesspasses', this.isActive('/mpup/accesspasses'))
  }

  getImagePath (icon: string, active?: boolean): string {
    const isMobile = this.breakpoint.isMatched('(max-width: 767px)')
    return `assets/images/Icon_${icon}${(isMobile && active) ? '_mobile' : ''}${active ? '_active' : ''}.svg`
  }

  isActive (routeName: string): boolean {
    if(routeName === '/mpup/home') {
      routeName = '/mpup'
    }
    const path = this.activeRoute.substring(this.activeRoute.indexOf('/mpup'))
    return routeName === path
  }
}
